import Home from "./Home";

function Explore({ result }) {
  return <Home result={result} />;
}

export default Explore;